import React from 'react'

type CollectionVenueCardProps = {
  title?: string
  image: React.ReactNode
}

export const CollectionVenueCard = ({
  image,
  title,
}: CollectionVenueCardProps) => (
  <div className="relative z-[1] mb-4 flex h-0 w-full items-center justify-center overflow-hidden rounded bg-surface-subtle p-4 pt-[calc(2/5*100%)] text-white">
    {image}

    <div className="absolute inset-0 flex items-center justify-center overflow-hidden bg-black/40 p-4">
      <h1 className="z-[2] text-center text-white my-heading-lg">{title}</h1>
    </div>
  </div>
)
